import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getPublicKey: () => ({
    url: 'sm/api/v1/WorkingKey/GetPublicKey',
    method: 'GET',
  }),
  exchangeEncryptedKey: (input) => ({
    url: 'sm/api/v1/WorkingKey/exchange',
    method: 'POST',
    data: input,
  }),
};

export default apis;
